import { createContext } from 'react';

/** Einstellungen der Sitzung von außen (Tests: eigene Weiterleitung und Wartezeit). */
export type SessionOptions = {
  assign?: (to: string) => void;
  getLocation?: () => { pathname: string; search: string };
  retryDelay?: number;
  fetch?: typeof fetch;
};

export const SessionOptionsContext = createContext<SessionOptions>({});
